
import React, { ReactElement, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import EmailNotificationAutomationModal from "./EmailNotificationAutomationModal"
import Select from "react-select"
import { OrderStatusTriggerable, OrderStatusAutomationConfiguration } from "./OrderStatusAutomation"
import { OrderStatus } from "./OrderStatus"
import Icon from "../common/icon/icon.component.jsx"

type Props = {
    triggerable: OrderStatusTriggerable
    onSave: () => void
    statuses: OrderStatus[]
}

const EmailNotificationAutomationComponent = (props: Props) => {

    const {
        triggerable: {
            id = "",
            attributes: {
                config: {
                    statusAutomationConfigs = []
                } = {}
            } = {}
        } = {}
    } = props
    const [modal, setModal] = useState<ReactElement>(<></>)
    const [statusConfigurations, setOrderStatusConfigurations]
        = useState<OrderStatusAutomationConfiguration[]>(statusAutomationConfigs || [])
    const { statuses } = props

    const allOptions = statuses.map(status => {
        return { label: status.attributes.name, value: status.id }
    })

    const options = [
        { label: <FormattedMessage id="order.status.completed_label" />, value: "", disabled: true },
        ...allOptions
    ]

    const onSave = (config: OrderStatusAutomationConfiguration) => {
        let newConfigurations = [...statusConfigurations]

        if (config.id !== "") {
            if (config.customStatusId !== "") {
                const index = newConfigurations.findIndex(existingConfig => existingConfig.id === config.id)
                index !== -1 ? newConfigurations[index] = config : newConfigurations.push(config)
            } else {
                newConfigurations = newConfigurations.filter(cfg => cfg.id !== config.id)
            }
        } else {
            if (config.customStatusId !== "") {
                newConfigurations.push(config)
            }
        }

        const payload = {
            isEnabled: newConfigurations.length !== 0,
            config: {
                statusAutomationConfigs: config,
            }
        }
        const request = id
            ? AppContext.getApiClient().patch(`/triggerables/${id}`, payload)
            : AppContext.getApiClient().post("/triggerables", {
                commandKey: "order-status-updated-notification-command",
                triggerKey: "order-status-notification-trigger",
                triggerableType: "order-status-automation",
                config: payload.config,
            })

        request.then(r => {
            const statusAutomationConfigs = r?.attributes?.config?.statusAutomationConfigs ?? []
            setOrderStatusConfigurations(statusAutomationConfigs.map(config => config as OrderStatusAutomationConfiguration))
            props.onSave()
        })

    }

    return (
        <>
            {
                statusAutomationConfigs.map(orderStatusConfig => {
                    return < div className="row my-2" key={orderStatusConfig.id || "new-order-status-config"}>
                        <div className="col-9 d-flex align-items-center">
                            <span>
                                <FormattedMessage
                                    id="triggers.trigger_type.order_status_update_trigger"
                                    defaultMessage="Send an email notification whenever the status changes to "
                                />
                            </span>

                            <span className="pl-2 w-25">
                                <Select
                                    disabled={true}
                                    clearable={true}
                                    options={options}
                                    value={orderStatusConfig.customStatusId}
                                    multi={false}
                                />
                            </span>
                        </div>

                        <div className="col-3 d-flex justify-content-end">
                            <button type="button" className="btn btn-primary w-75" onClick={() => {
                                setModal(<EmailNotificationAutomationModal
                                    configuration={orderStatusConfig}
                                    triggerableId={id}
                                    onClose={() => {
                                        setModal(<></>)
                                    }}
                                    onSave={(orderStatusConfig: OrderStatusAutomationConfiguration) => {
                                        onSave(orderStatusConfig)
                                    }}
                                />)
                                return
                            }}
                            >
                                <Icon value={"pen"} className={"mr-1"} />
                                <FormattedMessage
                                    id="triggers.trigger_type.order_status_update_trigger.update_btn"
                                    defaultMessage="Update status notification"
                                />
                            </button>
                        </div>
                    </div >
                })
            }
            <div className="row my-2" key={"create-order-status-automation-default"}>
                <div className="col-3 offset-9 d-flex justify-content-end">
                    <button type="button" className="btn btn-primary w-75" onClick={() => {
                        setModal(<EmailNotificationAutomationModal
                            onClose={() => {
                                setModal(<></>)
                            }}
                            onSave={(orderStatusConfig: OrderStatusAutomationConfiguration) => {
                                onSave(orderStatusConfig)
                            }}
                        />)
                        return
                    }}
                    >
                        <Icon value={"plus"} className={"mr-1"} />
                        <FormattedMessage
                            id="triggers.trigger_type.order_status_update_trigger.create_btn"
                            defaultMessage="Create status notification"
                        />
                    </button>
                </div>
            </div >
            {modal}
        </>
    )

    return
}

export default injectIntl(EmailNotificationAutomationComponent)


// WEBPACK FOOTER //
// ./src/order-status/EmailNotificationAutomationComponent.tsx